<template>
  <el-dialog
    custom-class="expriate-modal"
    center
    append-to-body
    :visible.sync="expriateVisible"
    width="380px"
    :before-close="hideModal"
    ><div slot="title" class="dialog-title">
      <div class="title">温馨提示</div>
    </div>
    <div class="expriate-modal-txt">
      尊敬的用户，您签署的连连钱袋<a>《免密免验代发协议》</a>
      {{
        htmlTxt === "EXPIRED" ? "已过期" : "即将到期"
      }}，过期后您的提现功能将受影响。
      <br />
      为了不影响您的提现，请尽快续签。
    </div>
    <div class="flex-row-center-center">
      <el-button type="primary" class="sign-btn" @click="goSign"
        >去签约</el-button
      >
    </div></el-dialog
  >
</template>
<script>
import { postPapAgreeApply, putPapAgreeModify } from "@/models/purseSet";
export default {
  data() {
    return { expriateVisible: false, corpId: undefined, htmlTxt: "" };
  },
  methods: {
    showModal(id, txt) {
      this.expriateVisible = true;
      this.corpId = id;
      this.htmlTxt = txt;
    },
    hideModal() {
      this.expriateVisible = false;
      this.corpId = undefined;
      if (this.htmlTxt === "EXPIRING_SOON") {
        this.$emit("goCash");
      }
      this.htmlTxt = "";
    },
    // 去签约
    async goSign() {
      try {
        const params = {
          // @ts-ignore
          companyId: this.corpId,
          agreementType: "WITH_HOLD", // 免密协议类型 WITH_HOLD：免密代扣 WITH_WITHDRAW：免密提现
          flagChnl: "H5", // 交易发起渠道 ANDROID IOS H5 PC 目前只支持H5
          returnUrl: window.location.href // 签署成功后的返回路径
        };
        const papApi =
          this.htmlTxt === "EXPIRED" ? postPapAgreeApply : putPapAgreeModify;
        const res = await papApi(params); // 免密协议申请
        const jumpUrl = res.data;

        if (jumpUrl) {
          window.open(jumpUrl); // 跳转连连免密签署
        }
      } catch (err) {
        this.$message.error(err.message || err);
      }
    }
  }
};
</script>

<style lang="scss">
.expriate-modal {
  border-radius: 2px;

  .el-dialog__header {
    background-color: #fff !important;
    text-align: center;
    padding: 10px 0 0 0 !important;
    border-radius: 2px;
    position: relative;
    .el-icon-close {
      color: #333 !important;
      font-size: 18px !important;
      margin-top: 8px !important;
    }
  }
  .expriate-modal-txt {
    padding: 0 10px;
    margin-bottom: 30px;
    font-size: 15px;
    a {
      color: #2186fc;
    }
  }
  .sign-btn {
    background: #2186fc !important;
    border: none !important;
    font-size: 13px;
    padding: 10px 20px;
    font-weight: normal;
    :hover {
      color: #fff !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/purseSetting/withdrawal/components/expriateModal.vue